export default {
    items: [] as string[],

    init() {
        const saved = localStorage.getItem("remoteshell_favorites");
        if (saved) {
            try {
                this.items = JSON.parse(saved);
            } catch (e) {
                console.error("Failed to parse favorites", e);
                this.items = [];
            }
        }
    },

    toggle(slug: string) {
        if (this.items.includes(slug)) {
            this.items = this.items.filter((i) => i !== slug);
        } else {
            this.items.push(slug);
        }
        this.save();
    },

    isSaved(slug: string) {
        return this.items.includes(slug);
    },

    clear() {
        this.items = [];
        this.save();
    },

    save() {
        localStorage.setItem("remoteshell_favorites", JSON.stringify(this.items));
    }
};